import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import template from './right-side-lots-list.vue';
import jQuery from 'jquery';

import carousel from 'vue-owl-carousel';

import { LiveData } from '../../views/live/index';

import { WebsocketsListener } from '../../utils/ws'

@Component({
    mixins: [template],
    components: {
        carousel
    }
})

export default class RightSideLotsList extends Vue {

    @Prop(Object) readonly auctionData!: LiveData;

    wsListener: WebsocketsListener

    constructor() {

        super()

        this.wsListener  = new WebsocketsListener;

    }

    doLike(lotId: string, like: boolean) {

        this.wsListener.sendPost('lots.like', { lot: lotId, like: like });

        this.wsListener.sendGet('lots', { auction: this.auctionData.auction._id });

    }

    showThisLot(index: number) {

        this.$store.state.currentShownLot = index;

    }

    created() {

        let lotsAffix       = 'isTrue',
            lotsAffixOffset = 20;

        window.onscroll = function() {
            affixLots();
        };

        function affixLots() {

            let actualScroll = jQuery(window).scrollTop();

            if (actualScroll) {

                if ( (actualScroll > lotsAffixOffset) && (lotsAffix === 'isTrue') ) {

                    jQuery('html').addClass('slots-affix');

                    lotsAffix = 'isFalse';

                } else if ( (actualScroll <= lotsAffixOffset) && (lotsAffix === 'isFalse') ) {

                    jQuery('html').removeClass('slots-affix');

                    lotsAffix = 'isTrue';

                }

            }

        }

    }

    mounted() {

    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/right-side-lots-list/index.ts